import styled from 'styled-components';

import { ReactComponent as Chevron } from '~/assets/chevron.svg';
import BrandLogo from '~/brands/components/BrandLogo';
import { FadeInAnimation, Link } from '~/components';
import { ThemeProp } from '~/theme/Themes';

const paddingHeader = '8px';
const breakpoint = '960px';
const minWidth = '210px';

export const Body = styled.div`
  flex-direction: row;
  flex: 1;
  display: flex;
  margin: 0;
`;

interface FooterLabelProps {
  $isCobrand?: boolean;
}
export const FooterLabel = styled.span<FooterLabelProps>`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  color: ${(props: ThemeProp & FooterLabelProps) =>
    props.$isCobrand ? props.theme.colors.neutrals.black : props.theme.colors.neutrals.white};
  opacity: 0.5;
  @media (max-width: ${breakpoint}) {
    color: ${(props: ThemeProp) => props.theme.colors.neutrals.c300};
    opacity: 1;
  }
`;

export const FooterLabelMobile = styled(FooterLabel)`
  @media (min-width: ${breakpoint}) {
    display: none;
  }
`;

export const SideBanner = styled.div`
  display: flex;
  flex-direction: column-reverse;
  min-width: 480px;
  width: 50%;
  @media (max-width: ${breakpoint}) {
    display: none;
  }
`;

export const Infographic = styled.div`
  position: absolute;
  background: ${(props: ThemeProp) => props.theme.gradients.welcome};
  background-size: cover;
  background-position: center center;
  width: 50%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
`;

export const RightScreen = styled(FadeInAnimation)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 50%;
  overflow-x: auto;
  min-height: 100vh;
  padding-left: 8.125rem;
  padding-right: 4rem;
  z-index: 3;
  @media (max-width: ${breakpoint}) {
    max-width: unset;
    width: 100%;
    padding-left: 4rem;
  }
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 0 24px;
  }
`;

export const HeaderContainer = styled.div`
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  background-size: 80% auto;
  flex-direction: row;
  padding: 0px ${paddingHeader} ${paddingHeader} 0;
  margin-top: 28px;
  flex-wrap: nowrap;
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: ${minWidth};
  @media (min-width: ${breakpoint}) and (max-width: ${(props: ThemeProp) => props.theme.breakpoints.large}) {
    justify-content: flex-end;
  }
`;

export const Logo = styled(BrandLogo)`
  align-self: center;
  @media (min-width: ${breakpoint}) and (max-width: ${(props: ThemeProp) => props.theme.breakpoints.large}) {
    display: none;
  }
`;

type PageContainerProps = {
  maxWidth?: string;
};

export const PageContainer = styled.div<PageContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
  overflow-y: visible;
  width: 100%;
  min-width: ${minWidth};
  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    max-width: ${({ maxWidth }: PageContainerProps) => maxWidth || '21.875rem'};
  }
  @media (max-width: ${breakpoint}) {
    align-self: center;
  }
`;

export const GoBackContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  justify-content: flex-start;
  margin-bottom: 0.4375rem;
  cursor: pointer;
`;

export const GoBackChevron = styled(Chevron)`
  transform: rotate(90deg);
  margin-right: 0.75rem;
  & path {
    stroke: ${(props: ThemeProp) => props.theme.colors.primary.c500} !important;
  }
`;

export const Title = styled.p`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-size: ${(props: ThemeProp) => props.theme.fontSize['3xl']};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight['3xl']};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
  margin: 0 0 24px 0;
  align-self: flex-start;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    font-size: ${(props: ThemeProp) => props.theme.fontSize.xl};
  }
`;

export const FooterContainer = styled.div`
  background-color: transparent;
  background-size: 80% auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 3rem;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 36px;
  min-width: ${minWidth};
  width: 100%;
  @media (max-width: ${breakpoint}) {
    padding: 24px 0;
  }
`;

export const RightFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 36px 0;
  min-width: ${minWidth};
  width: 100%;
  @media (max-width: ${breakpoint}) {
    padding: 24px 0;
    justify-content: center;
  }
`;

export const PrivacyPolicyLink = styled(Link)`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c300};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
`;
